const digitsAndSpace = (param) => {
    const pattern = new RegExp('^[0-9. ]*$')
    return !pattern.test(param);
}

const digits = (param) => {
    const pattern = new RegExp("^[0-9]+$")
    return !pattern.test(param)
}

const alphaAndNum = (param) => {
    const pattern = new RegExp("^[a-zA-Z0-9. ]*$")
    return !pattern.test(param);
}

const alphaOnly = (param) => {
    const pattern = new RegExp("^[a-zA-Z ]+$");
    return !pattern.test(param);
}

const speciesCodeValidator = (param) => {
    const speciesCodePattern = /^[0-9]{1,4}-[0-9]{1}$/;
    return !speciesCodePattern.test(param);
}

// const dateValidator = (param) => {
//     const datePattern = new RegExp('^(0[1-9]|[1-2][0-9]|3[0-1])-([a-zA-Z]{3})-\\d{4}$||^$');
//     return !datePattern.test(param);
// }

const dateValidator = (param) => {
    const trimmedParam = ('' + param).trim();
    
    // Allow empty string
    if (trimmedParam === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Validate format: DD-MMM-YYYY (e.g., 03-Nov-1986)
    // Day: 01-31, Month: Valid 3-letter abbreviation, Year: 4 digits
    const datePattern = /^(0[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{4}$/i;
    
    if (!datePattern.test(trimmedParam)) {
        return true; // Invalid format
    }
    
    // Additional validation: Check if the date is actually valid
    // Extract parts
    const parts = trimmedParam.split('-');
    const day = parseInt(parts[0], 10);
    const monthAbbr = parts[1];
    const year = parseInt(parts[2], 10);
    
    // Map month abbreviations to month numbers
    const monthMap = {
        'jan': 1, 'feb': 2, 'mar': 3, 'apr': 4, 'may': 5, 'jun': 6,
        'jul': 7, 'aug': 8, 'sep': 9, 'oct': 10, 'nov': 11, 'dec': 12
    };
    
    const month = monthMap[monthAbbr.toLowerCase()];
    
    // Validate day range for the specific month
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day > daysInMonth) {
        return true; // Invalid day for the month
    }
    
    return false; // Valid date
};


const sexValidator = (param) => {
    let sexVal = param
    if (
        sexVal === "Male" ||
        sexVal === "" ||
        sexVal === "Female" ||
        sexVal === "Unknown"
    ) {
        return true
    }
    return false;
}

const ageValidator = (param) => {
    if (
        param === "AD" ||
        param === "IMM" ||
        param === "JUV" ||
        param === "FG" ||
        param === "FW" ||
        param === "1Y" ||
        param === "" ||
        param === " "
    ) {
        return true
    }
    const agePattern = new RegExp('^[0-9. ]+$');
    return agePattern.test(param);
}

const ringSizeValidation = (param) => {
    if (["A", "AB", "B", "C", "F", "AA", "BC", "G", "K", "L", "M", "YZ", "Z", "NA"].includes(param)) {
        return true;
    } else {
        return false;
    }
}

const weightRingSizeValidation = (weight, ringSize) => {
    let weightRange = {
        "A": { "max": 80, "min": 8 },
        "AB": { "max": 150, "min": 22 },
        "B": { "max": 243, "min": 17 },
        "C": { "max": 1045, "min": 95 },
        "F": { "max": 1550, "min": 120 },
        "G": { "max": 1380, "min": 420 },
        "K": { "max": 3150, "min": 415 },
        "L": { "max": 5030, "min": 2120 },
        "Z": { "max": 31.9, "min": 6 },
    }
    try {
        return !(weight >= weightRange[ringSize]["min"] && weight <= weightRange[ringSize]["max"])
    }
    catch (err) {
        return true;
    }
}

// const localityValidation = (locality = "") => {
//     if (locality.trim().length === 0) {
//         return false;
//     }
//     return true;
// }

const localityValidation = (locality) => {
    if (locality == null) {
        return false;
    }
    const trimmedLocality = String(locality).trim();
    return trimmedLocality.length > 0;
};

// Numeric validator for fields like weight, wing, bill, tars
// Returns true if invalid, false if valid (consistent with other validators)
// Accepts: empty values, numbers, and floats (no spaces or letters)
const numericValidator = (param) => {
    // Allow empty values
    if (param === null || param === undefined || param === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Convert to string and trim
    const strValue = String(param).trim();
    
    // Allow empty string after trimming
    if (strValue === '') {
        return false; // Valid (empty is allowed)
    }
    
    const numericPattern = /^-?(\d+\.?\d*|\.\d+)$/;
    
    if (numericPattern.test(strValue)) {
        return false; // Valid
    } else {
        return true; // Invalid
    }
};

// Plumage validator: allows empty or numeric/float values between 0 and 9 (inclusive)
// Returns true if invalid, false if valid
const plumageValidator = (param) => {
    // Allow empty values
    if (param === null || param === undefined || param === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Convert to string and trim
    const strValue = String(param).trim();
    
    // Allow empty string after trimming
    if (strValue === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Check if it's a valid number or float
    const numericPattern = /^-?(\d+\.?\d*|\.\d+)$/;
    
    if (!numericPattern.test(strValue)) {
        return true; // Invalid (not a number)
    }
    
    // Convert to number and check range (0 to 9 inclusive)
    const numValue = parseFloat(strValue);
    
    if (isNaN(numValue)) {
        return true; // Invalid (cannot parse as number)
    }
    
    // Check if value is between 0 and 9 (inclusive)
    if (numValue >= 0 && numValue <= 9) {
        return false; // Valid
    } else {
        return true; // Invalid (out of range)
    }
};

// Moult validator: allows empty or numeric/float values between 0 and 10 (inclusive)
// Returns true if invalid, false if valid
const moultValidator = (param) => {
    // Allow empty values
    if (param === null || param === undefined || param === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Convert to string and trim
    const strValue = String(param).trim();
    
    // Allow empty string after trimming
    if (strValue === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Check if it's a valid number or float
    const numericPattern = /^-?(\d+\.?\d*|\.\d+)$/;
    
    if (!numericPattern.test(strValue)) {
        return true; // Invalid (not a number)
    }
    
    // Convert to number and check range (0 to 10 inclusive)
    const numValue = parseFloat(strValue);
    
    if (isNaN(numValue)) {
        return true; // Invalid (cannot parse as number)
    }
    
    // Check if value is between 0 and 10 (inclusive)
    if (numValue >= 0 && numValue <= 10) {
        return false; // Valid
    } else {
        return true; // Invalid (out of range)
    }
};

// Age numeric validator: allows empty or numeric/float values between 0 and 7 (inclusive)
// Returns true if invalid, false if valid
// Note: Age also accepts dropdown values (AD, IMM, JUV, etc.) which are validated separately
const ageNumericValidator = (param) => {
    // Allow empty values
    if (param === null || param === undefined || param === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Convert to string and trim
    const strValue = String(param).trim();
    
    // Allow empty string after trimming
    if (strValue === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Check if it's a valid number or float
    const numericPattern = /^-?(\d+\.?\d*|\.\d+)$/;
    
    if (!numericPattern.test(strValue)) {
        // If it's not numeric, it might be a dropdown value (AD, IMM, etc.) - those are valid
        // Return false (valid) for non-numeric values as they're handled by ageValidator
        return false;
    }
    
    // Convert to number and check range (0 to 7 inclusive)
    const numValue = parseFloat(strValue);
    
    if (isNaN(numValue)) {
        return true; // Invalid (cannot parse as number)
    }
    
    // Check if value is between 0 and 7 (inclusive)
    if (numValue >= 0 && numValue <= 7) {
        return false; // Valid
    } else {
        return true; // Invalid (out of range)
    }
};

// Brood validator: allows empty or numeric/float values between 1 and 4 (inclusive)
// Returns true if invalid, false if valid
const broodValidator = (param) => {
    // Allow empty values
    if (param === null || param === undefined || param === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Convert to string and trim
    const strValue = String(param).trim();
    
    // Allow empty string after trimming
    if (strValue === '') {
        return false; // Valid (empty is allowed)
    }
    
    // Check if it's a valid number or float
    const numericPattern = /^-?(\d+\.?\d*|\.\d+)$/;
    
    if (!numericPattern.test(strValue)) {
        return true; // Invalid (not a number)
    }
    
    // Convert to number and check range (0 to 9 inclusive)
    const numValue = parseFloat(strValue);
    
    if (isNaN(numValue)) {
        return true; // Invalid (cannot parse as number)
    }
    
    // Check if value is between 1 and 7 (inclusive)
    if (numValue >= 0 && numValue <= 9) {
        return false; // Valid
    } else {
        return true; // Invalid (out of range)
    }
};

export { digitsAndSpace, digits, alphaAndNum, alphaOnly, speciesCodeValidator, dateValidator, ageValidator, sexValidator, weightRingSizeValidation, ringSizeValidation, localityValidation, numericValidator, plumageValidator, moultValidator, ageNumericValidator, broodValidator }